module.exports = __webpack_public_path__ + "static/media/buttonsounds02.fdf09bbd.wav";